export enum GestionnaireFormFieldNames {
  CompanyName = 'companyName',
  Phone = 'phone',
  RegistrationNumber = 'registrationNumber',
  Capital = 'capital',
  RcsCity = 'rcsCity',
  RcsNumber = 'rcsNumber',
  OriasNumber = 'oriasNumber',
  Rcp = 'rcp',
  BankAccounts = 'bankAccounts',
  ComplaintEmail = 'complaintEmail',
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Username = 'username',
  Password = 'password',
  PlateformeIds = 'plateformeIds',
}
